declare var angular: any;
import { truncate, keys, groupBy, mapValues, mean } from 'lodash';
import * as moment from 'moment';

angular
  .module('UserHomeControllers')

  .directive('cfShowWarning', function() {
    return {
      restrict: 'E',
      templateUrl: '/ng1/www/modules/user/index/html/show_warning.html',
      controller: [
        '$scope',
        'pricing',
        function($scope, pricing) {
          $scope.open = function(ev) {
            pricing.showPrices(ev);
          };
        }
      ]
    };
  })

  .directive('cfExercisesChartExam', function() {
    return {
      restrict: 'E',

      scope: {
        exercises: '='
      },

      controller: [
        '$scope',
        '$http',
        'exam',
        'EXAM',
        function($scope, $http, exam, EXAM) {
          $scope.exam = EXAM;
          $scope.options = {
            pointLabelFontSize: 14
          };

          $scope.labels = [];
          $scope.smallLabels = [];
          $scope.data = [];

          let datas = $scope.exercises;
          if (EXAM === 'lerobert') {
            // groupBy SubCategory
            let x = Object.keys(datas).map(id => ({
              id,
              value: datas[id],
              subCategory: exam.getPartById(parseInt(id, 10)).subCategory
            }));

            datas = mapValues(groupBy(x, 'subCategory'), val => {
              return mean(val.map(v => v.value));
            });
          }

          var v = [];
          var i = 0;
          angular.forEach(datas, function(value, key) {
            if (value) {
              i++;
              $scope.smallLabels.push('Part ' + key);
              $scope.labels.push(getTitle(key));
              v.push(Math.round(100 * value));
            }
          });
          $scope.empty =
            i < exam.examData.student.home.showExercisesChartExam
              ? true
              : false;

          $scope.data.push(v);

          function getTitle(partId) {
            if (EXAM === 'toeic') {
              return (
                'Part ' +
                partId +
                ': ' +
                exam.partGetTitle(partId).split('/')[1]
              );
            }
            if (EXAM === 'lerobert') {
              return partId;
            }
            return exam.partGetTitle(partId);
          }
        }
      ],
      templateUrl: '/ng1/www/modules/user/index/html/exercises_chart.html'
    };
  })

  .directive('cfTuto', function() {
    return {
      restrict: 'E',
      template: '',
      controller: [
        '$scope',
        '$http',
        'API_URL',
        '$mdMedia',
        '$mdDialog',
        'exam',
        'EXAM',
        function($scope, $http, API_URL, $mdMedia, $mdDialog, exam, EXAM) {
          $mdDialog
            .show({
              controller: [
                '$scope',
                '$mdDialog',
                function($scope, $mdDialog) {
                  $scope.examData = exam.examData;
                  $scope.close = function() {
                    $mdDialog.hide();
                  };

                  $scope.exam = EXAM;

                  if (!(EXAM === 'lerobert' || EXAM === 'delf')) {
                    ($scope.superTitle = `Bienvenue sur Nathan ${exam.examData.name}`),
                      ($scope.title = '5 modules pour réussir votre examen'),
                      ($scope.tutos = [
                        {
                          label: 'Accueil - Dashboard',
                          title:
                            'Grâce au dashboard, fixez-vous un objectif et suivez votre progression au cours du temps.',
                          text:
                            "Commencez par définir votre objectif ! Il vous permettra de savoir quand vous êtes prêt pour votre examen. Ensuite, vous pouvez consulter des leçons, vous entraîner ou faire un examen blanc pour estimez votre niveau. Consultez aussi notre dossier pour des astuces et des informations complémentaires sur l'examen !",
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/initHome.png'
                        },
                        {
                          label: 'Cours',
                          title:
                            "Consultez l'ensemble des cours nécessaires à la réussite de l'examen !",
                          text:
                            'Les cours sont rangés par catégorie pour vous aider. Au fur et à mesure de votre progression, nous vous indiquerons quels cours réviser en priorité pour cibler vos difficultés !',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/lessonHome.png'
                        },
                        {
                          label: 'Entraînement',
                          title:
                            'Travaillez vos connaissances de manière ciblée et rapide.',
                          text:
                            'Sélectionnez la ou les parties sur lesquelles vous souhaitez travailler !',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/trainingHome.png'
                        },
                        {
                          label: 'Examen blanc',
                          title:
                            "Évaluez votre niveau et entraînez-vous à passer l'examen dans les mêmes conditions que le jour J !",
                          text:
                            'Passez du Listening au Reading comme vous le souhaitez et interrompez votre examen autant de fois que vous le souhaitez.',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/examHome.png'
                        },
                        {
                          label: 'Glossaire',
                          title: "Profitez d'un glossaire sur-mesure !",
                          text:
                            'Cherchez et ajoutez des mots à votre glossaire ! Vous pouvez aussi cliquer sur les mots que vous ne connaissez pas lors de la correction des exercices.',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/lexicon.png'
                        }
                      ]);
                  } else if (EXAM === 'lerobert') {
                    ($scope.superTitle =
                      'Bienvenue sur la Formation Le Robert'),
                      ($scope.title = '5 modules pour réussir votre examen'),
                      ($scope.tutos = [
                        {
                          label: 'Accueil',
                          title:
                            '<b>Retrouvez votre tableau de bord</b> avec <b>votre objectif, votre temps passé</b> à vous former ainsi que vos statistiques de compétences. Vous y trouverez également d’autres informations utiles pour votre formation.',
                          text: '',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/initHome.png'
                        },
                        {
                          label: 'Règles',
                          title:
                            "Consultez l'ensemble des cours nécessaires à la réussite de l'examen !",
                          text: '',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/lessonHome.png'
                        },
                        {
                          label: 'Entraînement',
                          title: `
                  Travaillez vos connaissances de manière ciblée et rapide.<br>
                  Sélectionnez la ou les parties sur lesquelles vous souhaitez travailler !<br>
                  Entraînez-vous sur les 16 modules proposés afin d’atteindre votre objectif. <br>
                  `,
                          text: '',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/trainingHome.png'
                        },
                        {
                          label: 'Tests',
                          title:
                            '<b>Testez-vous dans les conditions de l’examen.</b> Nous vous avons préparé 6 tests blancs complets conformes à la Certification Le Robert, pour finaliser vos révisions.',
                          text: '',
                          '/ng1/www/img':
                            '/ng1/www/img/help/' + EXAM + '/examHome.png'
                        }
                      ]);
                  } else if (EXAM === 'delf') {
                    ($scope.superTitle = 'Bienvenue sur la plateforme DELF'),
                      ($scope.title = '4 modules pour réussir votre examen'),
                      ($scope.tutos = [
                        {
                          label: 'Accueil',
                          title: '<b>Retrouvez votre tableau de bord</b>',
                          text: '',
                          '/ng1/www/img': ''
                        },
                        {
                          label: 'Focus Langue',
                          title:
                            "Consultez l'ensemble des cours nécessaires à la réussite de l'examen !",
                          text: '',
                          '/ng1/www/img': ''
                        },
                        {
                          label: 'Entraînement',
                          title: `
                  Travaillez vos connaissances de manière ciblée et rapide.<br>
                  Sélectionnez la ou les parties sur lesquelles vous souhaitez travailler !<br>
                  `,
                          text: '',
                          '/ng1/www/img': ''
                        },
                        {
                          label: 'Tests',
                          title:
                            '<b>Testez-vous dans les conditions de l’examen.</b> ',
                          text: '',
                          '/ng1/www/img': ''
                        }
                      ]);
                  }
                }
              ],
              templateUrl: '/ng1/www/modules/user/index/html/tuto.html',
              clickOutsideToClose: true,
              preserveScope: true,
              parent: angular.element(document.body),
              fullscreen: true,
              openFrom: {
                bottom: -50
              },
              closeTo: {
                bottom: -50
              }
            })
            .finally(function() {
              $scope.main.me.firstTime = false;
            });
        }
      ]
    };
  })

  .directive('cfShowObjective', function() {
    return {
      restrict: 'E',
      templateUrl: '/ng1/www/modules/user/index/html/show_objective.html'
    };
  })

  .component('cfBrightExam', {
    templateUrl: '/ng1/www/modules/user/index/html/show_bright_exam.html',
    controller: [
      'api',
      'ENVIRONMENT',
      function(api, ENVIRONMENT) {
        var self = this;
        this.$onInit = function() {
          api.getUserAssessments().then(function(data) {
            self.exams = data;
            self.token = api.data.token;
            self.nodeUrl = ENVIRONMENT.nodeUrl;
          });
        };
      }
    ]
  })

  .directive('cfShowObjective', function() {
    return {
      restrict: 'A',
      link: function(scope, element) {
        element.on('click', function(ev) {
          (scope as any).showEditExamObjective(ev);
        });
      },
      controller: [
        '$scope',
        '$mdDialog',
        function($scope, $mdDialog) {
          // Call dialog to edit toeic objective
          $scope.showEditExamObjective = function(ev) {
            $mdDialog
              .show({
                clickOutsideToClose: true,
                preserveScope: true,
                parent: angular.element(document.body),
                templateUrl:
                  '/ng1/www/modules/user/index/html/exam_objective_dialog.html',
                targetEvent: ev,
                locals: {
                  objective: $scope.main.me.profile.objective
                },
                controller: [
                  'scope',
                  '$mdDialog',
                  '$mdToast',
                  'objective',
                  'api',
                  'exam',
                  function(scope, $mdDialog, $mdToast, objective, api, exam) {
                    scope.options = {
                      min: exam.getMin(),
                      max: exam.getMax(),
                      step: exam.getStep()
                    };

                    scope.exam = exam;

                    scope.objective = objective;

                    scope.cancel = function() {
                      $mdDialog.cancel();
                    };

                    scope.confirm = function() {
                      api.changeObjective(scope.objective).then(
                        function() {
                          $mdToast.show(
                            $mdToast
                              .simple()
                              .textContent(
                                "Votre objectif d'examen a été mis a jour"
                              )
                              .position('bottom right')
                          );
                        },
                        function(data) {
                          console.log(data);
                          $mdToast.show(
                            $mdToast
                              .simple()
                              .textContent('Une erreur est survenue')
                              .position('bottom right')
                          );
                        }
                      );
                      $mdDialog.hide(scope.objective);
                    };
                  }
                ]
              })
              .then(function(objective) {
                // After closing the dialog we update the objective in main scope
                if (objective) {
                  $scope.main.me.profile.objective = objective;
                }
              });
          };
        }
      ]
    };
  })

  .directive('cfProfileExam', function() {
    return {
      scope: {
        stats: '=stats',
        main: '=',
        role: '='
      },
      restrict: 'E',
      replace: true,
      templateUrl: '/ng1/www/modules/user/index/html/profile_exam.html',
      controller: [
        '$scope',
        '$mdToast',
        '$window',
        'lesson',
        'exam',
        function($scope, $mdToast, $window, lesson, exam) {
          $scope.examData = exam.examData;
          $scope.openLesson = function(id, ev) {
            lesson.dialogDetail(id, ev);
          };

          $scope.setCurrentTraining = function(type) {
            $window.localStorage.currentTraining = type;
          };

          $scope.setCurrentExam = function(type) {
            $window.localStorage.currentTrainingExam = type;
          };

          $scope.exam = exam;
        }
      ]
    };
  })

  .directive('cfEmailForGift', function() {
    return {
      restrict: 'E',
      templateUrl: '/ng1/www/modules/user/index/html/email_for_gift.html',
      controller: [
        '$scope',
        '$mdToast',
        'api',
        function($scope, $mdToast, api) {
          $scope.submit = function(isValid) {
            if (isValid) {
              api.changeEmail($scope.email).then(
                function(data) {
                  api.me();
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent('Vos changements ont bien été sauvegardés')
                      .position('bottom right')
                  );
                },
                function(error) {
                  console.log(error);
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent('Cette adresse email est déja utilisée')
                      .position('top right')
                  );
                }
              );
            }
          };
        }
      ]
    };
  })

  .directive('cfPlan', function() {
    return {
      scope: {
        expiration: '=',
        role: '='
      },
      restrict: 'E',
      templateUrl: '/ng1/www/modules/user/index/html/plan.html',
      controller: [
        '$scope',
        'pricing',
        'exam',
        function($scope, pricing, exam) {
          $scope.exam = exam.examData;
          $scope.$watch('expiration', function(newValue, oldValue) {
            if ($scope.expiration) {
              console.log($scope.expiration);
              var d = moment.utc($scope.expiration);
              var t = moment.utc().add(5, 'minute');
              var s = d.diff(t, 'days');

              if (s === 0 && d.isBefore(t)) {
                s = -1;
              }
              /*
            console.log('d', d.toISOString(), $scope.expiration);
            console.log('t', t.toISOString());
            console.log('s', s);
            */

              $scope.leftDays = s;
              $scope.isPremium =
                moment.utc($scope.expiration) > moment.utc().add(5, 'minute');
            }
          });

          $scope.showPlan = function(ev) {
            pricing.showPrices(ev);
          };
        }
      ]
    };
  });
